module.exports = __webpack_public_path__ + "static/media/quebonBakery.0fe59984.png";